// Status formatting functions for applicant management
// Central labels mapping so text can be updated in one place 
export const STATUS_LABELS = {
    not_sent: 'Not Sent',
    pending: 'Pending',
    in_progress: 'In Progress',
    completed: 'Completed',
    stopped_by_applicant: 'Stopped by Applicant',
    abandoned: 'Abandoned',
    closed: 'Closed',
    ats_declined: 'Rejected',
    requested_human_interview: 'Requested Human Interview',
    unsupported_region: 'Unsupported region',
};

export const formatStatus = (status) => {
    if (!status) return 'Unknown';
    const normalized = String(status).toLowerCase();
    if (STATUS_LABELS[normalized]) return STATUS_LABELS[normalized];
    if (normalized === 'feedback') return 'Completed';
    return normalized
        .split('_')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
};

export const getDisplayStatus = (applicant) => {
    if (applicant?.interview_session?.is_closed || applicant?.is_closed) {
        return 'closed';
    }

    if (applicant?.status === 'NEW') {
        return 'not_sent';
    }

    if (applicant?.status === 'ATS_DECLINED') {
        return 'ats_declined';
    }

    // Handle CONTACTED status without interview session (e.g., after failed resend)
    if (applicant?.status === 'CONTACTED' && !applicant?.interview_session) {
        return 'not_sent';
    }

    // Check if it has interview_session
    if (applicant?.interview_session?.status) {
        const sessionStatus = applicant.interview_session.status.toLowerCase();
        if (sessionStatus === 'feedback') {
            return 'completed';
        }
        return sessionStatus || 'unknown';
    }

    return applicant.status?.toLowerCase() || 'unknown';
};

export const statusFilterOptions = [
    { value: 'all', label: 'All' },
    { value: 'not_sent', label: STATUS_LABELS.not_sent },
    { value: 'ats_declined', label: STATUS_LABELS.ats_declined },
    { value: 'pending', label: STATUS_LABELS.pending },
    { value: 'in_progress', label: STATUS_LABELS.in_progress },
    { value: 'completed', label: STATUS_LABELS.completed },
    { value: 'stopped_by_applicant', label: STATUS_LABELS.stopped_by_applicant },
    { value: 'unsupported_region', label: STATUS_LABELS.unsupported_region },
    { value: 'abandoned', label: STATUS_LABELS.abandoned },
    { value: 'closed', label: STATUS_LABELS.closed },
    { value: 'requested_human_interview', label: STATUS_LABELS.requested_human_interview }
];
